import React from "react";
import classNames from "classnames";
import { SvgBrandIcyVeins } from "@ugitgud/legos/ui/icon/SVG/BrandIcyVeins";
import { SvgGameWowDetailed } from "@ugitgud/legos/ui/icon/SVG/GameWowDetailed";

const CLASS_CODEX_ICON = "https://static.bigbrain.gg/assets/ugg/pages/desktop-app/wow/wow-class-codex-icon.webp";
const CLASS_CODEX_PREVIEW = "https://static.bigbrain.gg/assets/ugg/pages/desktop-app/wow/wow-class-codex-img.webp";
const ICY_VEINS_DESKTOP_PREVIEW = "https://static.bigbrain.gg/assets/ugg/pages/desktop-app/wow/wow-icy-veins.webp";

const SECTION = "flex items-center gap-[60px] max-sm:flex-col max-sm:items-start max-sm:gap-[32px]";
const SECTION_COPY = "flex flex-[0_0_354px] max-w-[354px] flex-col items-start max-sm:flex-none max-sm:max-w-full";
const SECTION_PREVIEW =
  "aspect-[602/339] h-auto w-full max-w-[602px] flex-[1_1_602px] rounded-[6px] object-cover max-sm:flex-none";
const SECTION_HEADING = "flex items-center gap-[12px]";
const SECTION_TITLE = "m-0 text-[24px] font-extrabold leading-normal text-white";
const SECTION_SUBTITLE = "m-0 mt-[3px] text-[14px] font-normal leading-normal text-lavender-50";
const SECTION_DESCRIPTION = "m-0 mt-[24px] text-[16px] font-normal leading-[24px] text-lavender-50";

const TAG =
  "inline-flex h-[30px] items-center justify-center gap-[10px] whitespace-nowrap rounded-[3px] px-[18px] text-[14px] leading-normal text-white";

export function WoWFeatureSpotlight() {
  return (
    <div className="mt-[80px] flex w-full flex-col gap-[120px] font-inter">
      <section className={SECTION}>
        <div className={SECTION_COPY}>
          <div className="mb-[24px] flex gap-[12px]">
            <span className={classNames(TAG, "bg-accent-blue-400 font-bold")}>NEW</span>
            <span className={classNames(TAG, "bg-lavender-50/20 font-semibold")}>
              <SvgGameWowDetailed className="h-[18px] w-[18px] shrink-0" />
              Addon
            </span>
          </div>
          <div className={SECTION_HEADING}>
            <img src={CLASS_CODEX_ICON} alt="" width={46} height={46} className="h-[46px] w-[46px] shrink-0 rounded-[6px]" />
            <div>
              <h2 className={SECTION_TITLE}>Class Codex</h2>
              <p className={SECTION_SUBTITLE}>World of Warcraft Addon</p>
            </div>
          </div>
          <p className={SECTION_DESCRIPTION}>
            The New Class Codex addon gives you the best recommendations for{" "}
            <strong className="font-semibold text-white">Talents, BiS Gear, Stats, Rotations and more</strong>, all within the
            game. Only available within the Icy Veins app.
          </p>
        </div>
        <img src={CLASS_CODEX_PREVIEW} alt="Class Codex in-game overlay" width={602} height={339} className={SECTION_PREVIEW} />
      </section>

      <section className={classNames(SECTION, "flex-row-reverse")}>
        <div className={SECTION_COPY}>
          <div className={SECTION_HEADING}>
            <SvgBrandIcyVeins className="h-[38px] w-[61px] shrink-0" role="img" aria-label="Icy Veins" />
            <div>
              <h2 className={SECTION_TITLE}>Icy Veins</h2>
              <p className={SECTION_SUBTITLE}>Now on Your Desktop</p>
            </div>
          </div>
          <p className={SECTION_DESCRIPTION}>
            Browse all your go-to Class Guides, Talent Recommendations, Rotation Breakdowns, and Tier Lists for Retail WoW.
            Classic Support Coming Soon.
          </p>
        </div>
        <img
          src={ICY_VEINS_DESKTOP_PREVIEW}
          alt="Icy Veins on the desktop app"
          width={602}
          height={339}
          className={SECTION_PREVIEW}
        />
      </section>
    </div>
  );
}

export default WoWFeatureSpotlight;
